import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
(window as MSafeAny).__Zone_disable_customElements = true;
